<template>
  <modal name="satelliteAgentUpdate" :width="520" height="auto" :scrollable="true" classes="creative-modal">
    <div class="agent-update-modal text-center">
      <svg v-svg @click="$modal.hide('satelliteAgentUpdate')" class="close" symbol="modal-close" size="0 0 15 15" role="info"></svg>
      <h3 class="modal-title pt-2">{{ $t("satellites.update.confirm") }}</h3>
      <template v-if="satellite">
        <div class="agent-update-modal__name pt-2">{{ satName(satellite) }}</div>
        <p class="sat-muted mt-2">{{ confirmText }}</p>
      </template>
      <div class="d-flex justify-content-center mt-4" style="gap: 10px">
        <button class="btn _bg-gray" @click="$modal.hide('satelliteAgentUpdate')">{{ $t("cancel") }}</button>
        <button class="btn _bg-green" :disabled="busy || !satellite" @click="confirm">{{ $t("satellites.update.button") }}</button>
      </div>
    </div>
  </modal>
</template>
<script>
import satelliteService from "@/api/satelliteService";
import { formatMixin, isOk } from "@/components/Satellites/format";

// Confirms and requests a calypso update of the satellite; emits "updated" with the satellite as the API returns it.
export default {
  name: "AgentUpdateModal",
  mixins: [formatMixin],
  props: {
    satellite: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    confirmText() {
      const update = this.satellite.agent_update || {};
      return this.$t("satellites.update.confirm_text", { from: this.satellite.agent_version, to: update.latest_version });
    },
  },
  methods: {
    confirm() {
      if (this.busy || !this.satellite) return;
      this.busy = true;
      satelliteService
        .requestAgentUpdate(this.satellite.id)
        .then((res) => {
          if (isOk(res)) {
            this.$modal.hide("satelliteAgentUpdate");
            this.$alert({ type: "success", title: this.$t("satellites.update.requested") });
            this.$emit("updated", res.data);
          } else {
            this.showError(res);
          }
        })
        .finally(() => {
          this.busy = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.agent-update-modal {
  position: relative;
  padding: 16px 24px 24px;
}

.agent-update-modal__name {
  color: var(--sat-accent);
  font-weight: 500;
}
</style>
